import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FoodCategoriesHome from './categories/categories-home';
import FoodItemsHome from './foods/food-items-home';
import FoodLogHome from './food-log/food-log-home';
import FoodCalendarHome from './food-calendar/food-calendar-home';
import ExportFoodDataHome from './export/export-home';
import FoodGoalsHome from './goals/goals-home';

const FoodHome = () => {

    const { pathname } = useLocation();

    useEffect(() => {
        document.title = 'Food | Productivity';
    }, []);

    return (
        <div className="flex flex-col flex-1 leading-7 h-screen relative z-50 bg-white w-screen">
            <div className="overflow-auto px-6 pb-10">
                {
                    pathname === '/food' && <FoodLogHome/>
                }

                {
                    pathname === '/food/food-items' && <FoodItemsHome/>
                }

                {
                    pathname === '/food/categories' && <FoodCategoriesHome/>
                }

                {
                    pathname === '/food/calendar' && <FoodCalendarHome/>
                }

                {
                    pathname === '/food/export' && <ExportFoodDataHome/>
                }

                {
                    pathname === '/food/goals' && <FoodGoalsHome/>
                }

            </div>
        </div>
    )
};

export default FoodHome;